import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const SCModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(${pxToRem(10)});
  -webkit-backdrop-filter: blur(${pxToRem(10)});
`

interface SCModalContentProps {
  $opacity?: boolean;
}
export const SCModalContent = styled.div<SCModalContentProps>`
  background: white;
  opacity: ${({ $opacity }) => ($opacity ? '0.85' : '1')};
  color: black;
  padding: ${pxToRem(20)};
  border-radius: ${pxToRem(16)};
  width: 80vw;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 0 ${pxToRem(20)} rgba(0, 0, 0, 0.3);
  font-size: ${pxToRem(14)};
  line-height: 1.5;
  margin-bottom: ${pxToRem(100)};
`

export const SCModalTitle = styled.h3`
  color: black;
  font-size: ${pxToRem(18)};
  font-weight: 700;
  text-align: center;
  margin-top: ${pxToRem(20)};
  font-family: ${({ theme }) => theme.title_font || `'Nunito', sans-serif`};
`

export const SCModalDescription = styled.div`
  color: black;
  font-size: ${pxToRem(16)};
  text-align: center;
  margin-top: ${pxToRem(12)};
  font-family: ${({ theme }) => theme.text_font || `'Nunito', sans-serif`};

  & > p {
    text-align: left;
    margin-bottom: ${pxToRem(16)};
  }
`

export const SCModalButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${pxToRem(10)};
  margin-top: ${pxToRem(20)};
`

interface SCModalButtonProps {
  theme: any;
  $outlined?: boolean;
}
export const SCModalButton = styled.button<SCModalButtonProps>`
  flex: 1;
  background-color: ${({ $outlined, theme }) =>
    $outlined ? '#ebedf0' : theme.photobooth_button_color || theme.button_color || '#34b076'};
  color: ${({ $outlined }) => ($outlined ? 'black' : 'white')};
  border-radius: ${pxToRem(20)};
  font-weight: 600;
  font-size: ${pxToRem(12)};
  height: ${pxToRem(39)};
`
